import btnStyle from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import inputStyle from '@/components/Shares/Input.module.css';
import { gunterzBold } from '@/theme/fonts';
import { type AddPaymentFormType, DIALOG, type InfoPaymentDialogProps } from '@/types';
import { useLingui } from '@lingui/react';
import { Button, Group, Image, Input, Modal, SimpleGrid, Stack, Text, Tooltip } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconHelp } from '@tabler/icons-react';
import type { InfoAddPaymentFormProps } from './InfoAddPaymentModal';
import styles from './InfoAddPaymentModal.module.css';
import classes from './InfoDialogViews.module.css';
export type InfoEditPaymentFormProps = Omit<AddPaymentFormType, 'savePayment'>;
export const InfoEditPaymentModal: React.FC<InfoPaymentDialogProps> = ({
  openDialog,
  setOpenDialog
}) => {
  const {
    i18n
  } = useLingui();
  const form = useForm<InfoAddPaymentFormProps>({
    mode: 'uncontrolled',
    initialValues: {
      cardNumber: '',
      nameOfCard: '',
      expiryDate: '',
      cvv: ''
    }
  });
  const handleConfirm = (values: InfoAddPaymentFormProps) => {
    console.log(values);
    setOpenDialog(null);
  };
  return <Modal.Root opened={openDialog === DIALOG.EDIT_PAYMENT} onClose={() => setOpenDialog(null)} centered classNames={classes}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title className={gunterzBold.className}>
            {i18n._('Edit card details')}
          </Modal.Title>
          <Modal.CloseButton fz={24} />
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={form.onSubmit(handleConfirm)}>
            <Stack>
              <Image h={20} w={110} my={10} alt="payment method" src="/assets/wallet/visa-master-card.svg" />

              <Stack gap={5}>
                <Text fz="xs" fw={700} c="var(--text-dark)" tt="uppercase">
                  {i18n._('Card number')}
                </Text>
                <Input h={40} rightSection={<Icons className="icon-pr-line-card" fontSize={24} />} classNames={{
                input: inputStyle.input_style_2
              }} key={form.key('cardNumber')} {...form.getInputProps('cardNumber')} />
              </Stack>

              <Stack gap={5}>
                <Text fz="xs" fw={700} c="var(--text-dark)" tt="uppercase">
                  {i18n._('Name on card')}
                </Text>
                <Input h={40} classNames={{
                input: inputStyle.input_style_2
              }} key={form.key('nameOfCard')} {...form.getInputProps('nameOfCard')} />
              </Stack>

              <SimpleGrid cols={2}>
                <Stack gap={5}>
                  <Text fz="xs" fw={700} c="var(--text-dark)" tt="uppercase">
                    {i18n._('Expiry date')}
                  </Text>
                  <Input h={40} placeholder="mm/yy" classNames={{
                  input: inputStyle.input_style_2
                }} key={form.key('expiryDate')} {...form.getInputProps('expiryDate')} />
                </Stack>

                <Stack gap={5}>
                  <Group gap={4}>
                    <Text fz="xs" fw={700} c="var(--text-dark)" tt="uppercase">
                      {i18n._('cvv')}
                    </Text>
                    <Tooltip withArrow arrowSize={6} position="right-end" arrowPosition="center" classNames={styles} offset={{
                    mainAxis: 5,
                    crossAxis: 8
                  }} label={i18n._('3-digit code on the back of your card')} transitionProps={{
                    transition: 'fade-right',
                    duration: 300
                  }}>
                      <IconHelp size={14} stroke={3} color="var(--text-grey-2)" />
                    </Tooltip>
                  </Group>
                  <Input h={40} classNames={{
                  input: inputStyle.input_style_2
                }} key={form.key('cvv')} {...form.getInputProps('cvv')} />
                </Stack>
              </SimpleGrid>

              <Group mt={8} justify="flex-end">
                <Button fz={13} h={46} w={96} classNames={btnStyle} type="submit">
                  {i18n._('Save')}
                </Button>
              </Group>
            </Stack>
          </form>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>;
};